export default __webpack_public_path__ + "static/about_hero-fa7bdfa328fe6d35cbeb08f157626da8.jpg";